'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// shim "fetch" if it isn't available
if (!global.fetch) require('isomorphic-fetch'); /* global fetch */


var defaults = {
  apiUrl: 'https://api.fridgecms.com/v2'
};

var Fridge = function () {
  function Fridge(options) {
    (0, _classCallCheck3.default)(this, Fridge);

    this.options = (0, _extends3.default)({}, defaults, options);
  }

  (0, _createClass3.default)(Fridge, [{
    key: 'get',
    value: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this._request('get', url, null, options);
    }
  }, {
    key: 'post',
    value: function post(url) {
      var json = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this._request('post', url, json, options);
    }
  }, {
    key: 'put',
    value: function put(url) {
      var json = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this._request('put', url, json, options);
    }
  }, {
    key: 'delete',
    value: function _delete(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this._request('delete', url, null, options);
    }
  }, {
    key: '_request',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(method, path, json, options) {
        var requestOptions, q, url, res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestOptions = { headers: {}, method: method };


                if (this.options.token) {
                  // Bearer?
                  requestOptions.headers['Authorization'] = this.options.token;
                }

                if (this.options.fridgeId) {
                  options.site_id = this.options.fridgeId;
                }

                if (json && (method === 'post' || method === 'put')) {
                  requestOptions.headers['Content-Type'] = 'application/json';
                  requestOptions.body = (0, _stringify2.default)(json);
                }

                if (options.body) {
                  requestOptions.body = options.body;
                  delete options.body;
                }

                if (options.headers) {
                  requestOptions.headers = (0, _extends3.default)({}, requestOptions.headers, options.headers);
                  delete options.headers;
                }

                if (options.credentials) {
                  requestOptions.credentials = options.credentials;
                  delete options.credentials;
                }

                q = _qs2.default.stringify(options);
                url = this.options.apiUrl + '/' + path.replace(/^\//g, '') + (q.length ? '?' + q : '');
                _context.next = 11;
                return fetch(url, requestOptions);

              case 11:
                res = _context.sent;
                return _context.abrupt('return', res.headers.get('Content-Type').match(/json/) ? res.json() : res.text());

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _request(_x7, _x8, _x9, _x10) {
        return _ref.apply(this, arguments);
      }

      return _request;
    }()
  }], [{
    key: 'client',
    value: function client(options) {
      return new Fridge(options);
    }
  }]);
  return Fridge;
}();

module.exports = Fridge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fridge/dist/index.js
// module id = 753
// module chunks = 0